const getAllContextGames = (contexts) => {
    const games = [];
    contexts.forEach((context) => {
        if (context.selectedGames) {
            games.push(context.selectedGames);
        }
    });
    return games;
};

const setContextGamesToRuleById = (rule, gamingContextInfo) => {
    if (rule.gameRoundRuleInfo && rule.gameRoundRuleInfo.gamingContextCodes) {
        if (gamingContextInfo.gamingContexts) {
            const contextsByRuleCode = gamingContextInfo.gamingContexts
                .filter((context) => {
                    return rule.gameRoundRuleInfo.gamingContextCodes.includes(context.code);
                });
            const allContextGames = getAllContextGames(contextsByRuleCode).flat();
            if (rule.gameRoundRuleInfo.games) {
                rule.gameRoundRuleInfo.games = allContextGames;
            }
        }
    }
};

export default () => reducer => (state, action) => {
    const nextState = reducer(state, action);
    const { details } = nextState;

    if (details !== state.details) {
        const { leaderboardRules, gamingContextInfo } = details;
        const originalLeaderboardRules = leaderboardRules;
        const availableRules = leaderboardRules;

        // Set games from contexts to game round rules type.
        availableRules.forEach((rule) => {
            setContextGamesToRuleById(rule, gamingContextInfo);
        });
        // Set games from contexts to all rules types.
        originalLeaderboardRules.forEach((rule) => {
            setContextGamesToRuleById(rule, gamingContextInfo);
        });

        return {
            ...nextState,
            details: {
                ...details,
                leaderboardRules: availableRules,
                originalLeaderboardRules
            }
        };
    }

    return nextState;
};
